export const analyticsTheme = {
    colors: {
        pageBg: "#F4F7FB",
        pageBgSoft: "#F8FAFC",
        cardBg: "#FFFFFF",
        border: "#DCE5F0",
        borderStrong: "#C7D5E5",
        primary: "#0B1F3A",
        primarySoft: "#E9EEF6",
        textPrimary: "#12243E",
        textSecondary: "#3E526E",
        textMuted: "#6B7C95",
        accentBlue: "#3258D8",
        accentPurple: "#6A4DCC",
        accentCyan: "#1F8AA6",
        success: "#168A58",
        successBg: "#E8F6EF",
        warning: "#B66A17",
        warningBg: "#FFF4E8",
        danger: "#C03C3C",
        dangerBg: "#FCECED",
        chipBg: "#EEF3F9",
        focusRing: "#7AA3FF",
    },
    spacing: {
        xxs: "4px",
        xs: "8px",
        sm: "12px",
        md: "16px",
        lg: "20px",
        xl: "24px",
        xxl: "32px",
    },
    radius: {
        sm: "8px",
        md: "12px",
        lg: "16px",
        xl: "20px",
        full: "999px",
    },
    shadows: {
        soft: "0 8px 24px rgba(11, 31, 58, 0.06)",
        medium: "0 14px 36px rgba(11, 31, 58, 0.08)",
    },
    typography: {
        fontFamily:
            '"IBM Plex Sans", "Avenir Next", "Segoe UI", "Helvetica Neue", sans-serif',
        headingWeight: 700,
        bodyWeight: 500,
        metricWeight: 700,
        lineHeight: 1.35,
    },
} as const;
